//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import DJAreaSideMenu from './sidemenu';
//import Share from '../components/share/share';
//import Gallery from 'react-photo-gallery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
//import axios from 'axios';
//import {Text} from 'react-native';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
//import { ButtonGroup } from 'react-bootstrap';
//import Form from 'react-bootstrap/Form';
//import ProgressBar from 'react-bootstrap/ProgressBar';

import './css/seo.css';

export default class AdminSEO extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			auth: {},
		};
		this.getAuth = this.getAuth.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		await this.getAuth();

	}

	componentWillUnmount() {
	}

	async getAuth() {
		var params = new URLSearchParams();
		const x = await postApi('/api/v2/admin/auth', params);
		//console.log(x.data);
		this.setState({status: true, auth: x.data});
	}


	render() {
		const auth = 
      Object.keys(this.state.auth).map((e,i) => {
        return (
					<Col xs={12} key={i}>
						<Row className="gx-0 pb-3">
							<Col xs={3}><p>{e}</p></Col>
							<Col>
								{this.state.auth[e].connected?
									<>
										<Button size="sm" disabled>Disconnect</Button>
									</>
								:
									<>
										<a href={this.state.auth[e].url} target="_blank" rel="noreferrer"><Button size="sm">Authenticate</Button></a>
									</>
								}
							</Col>
						</Row>
					</Col>
        )
      })
		return (
			<>
				{this.state.status &&
					<Row className="dj-area pt-4 pb-5 px-4">
						<Col xs={12} md={2} className="djarea-sidemenu">
							<DJAreaSideMenu />
						</Col>
						{this.state.status &&
							<Col>
								<Row>
									{this.state.auth &&
										<Col xs={12}>
											<div className="card bg-dark">
													
												<div className="card-header">
													<h3 className="card-title">OAuth Authentiacte</h3>
													<div className="card-tools">
													</div>
												</div>
												<div className="card-body admin-seo">
													<Row>

													
													
														{auth}
													</Row>
												</div>
											</div>
										</Col>
									}
								</Row>
							</Col>
						}
					</Row>
					}
			</>
		);
	}
}
